import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import * as actions from '../../../store/actions/index';
import InsightCard from '../../InsightCard';

function checkColor(title) {
    let color;
    switch (title) {
        case 'Documentos em aberto':
            color = 'agreement';
            break;
        case 'Documentos vencidos':
            color = 'canceled';
            break;
        case 'Documentos a vencer':
            color = 'completed';
            break;
        case 'Documentos quitados':
            color = 'debtors';
            break;
        default:
            break;
    }
    return color;
}

const Card = (props) => (
    <div
        style={{
            cursor: 'pointer',
            margin: 10,
            backgroundColor: '#fff',
        }}
        onClick={() => {
            props.resetCurrentFilter('/financialDocuments');
            props.onInitFinancialDocuments(props.filter);
            props.onInitFinancialDocumentsCount(props.filter);
            props.onInitCard(true);
            props.onInitCardQuery(props.filter);
        }}
    >
        {props.redirect && <Redirect to='/financialDocuments' />}
        <InsightCard
            iconStatus={checkColor(props.title)}
            title={props.title}
            secondaryText={props.secondaryText}
            infoText={props.textBody}
        />
    </div>
);

const mapDispatchToProps = (dispatch) => {
    return {
        onInitFinancialDocuments: (filter) =>
            dispatch(actions.initFinancialDocuments(filter)),
        onInitCard: (bool) => dispatch(actions.setCard(bool)),
        onInitFinancialDocumentsCount: (filter) =>
            dispatch(actions.initFinancialDocumentsCount(filter)),
        resetCurrentFilter: (...args) =>
            dispatch(actions.resetCurrentFilter(...args)),
        onInitCardQuery: (query) => dispatch(actions.setCardQuery(query)),
    };
};
const mapStateToProps = (state) => {
    return {
        redirect: state.financialDocumentsReducer.redirect,
    };
};

export default injectIntl(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(Card),
);
